// Shared hook that reads the platform fee (single source of truth from
// /api/platform/fee) once per session and caches it in-memory. All UI
// surfaces that show or apply the fee (FX widget, withdrawal confirm,
// eFIRA display) use this so the admin's fee-settings change propagates
// everywhere on the next render.
import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let _cached = null;

export function usePlatformFee(fallbackPct = 0.005) {
  const [pct, setPct] = useState(_cached ?? fallbackPct);

  useEffect(() => {
    if (_cached !== null) return;
    axios
      .get(`${BACKEND_URL}/api/platform/fee`)
      .then((r) => {
        _cached = Number(r.data?.fee_pct ?? fallbackPct);
        setPct(_cached);
      })
      .catch(() => {
        // Silent — fee display already fell back to a sane default. Not
        // worth alerting the user; the admin fee page still reads live
        // via its own API call.
      });
  }, [fallbackPct]);

  return pct;
}

// Force a re-fetch after the admin updates the fee on their own settings
// page — cheap invalidation so their next navigation shows the new value.
export function invalidatePlatformFeeCache() {
  _cached = null;
}
